import {
  createRouter,
  createWebHistory
} from 'vue-router'

import HomeView from '../views/HomeView.vue'
import Project from '../views/Project.vue'
import Archievements from '../components/Archievements.vue'
import Contact from '../components/Contact.vue'

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/project',
    name: 'project',
    component: Project
  },
  {
    path: '/archievements',
    component : Archievements
  },
  {
    path :'/contact',
    component: Contact
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router